module.exports = __webpack_public_path__ + "static/MR_APR19_Wizard_Of_Oz_600x600px-149308951d99661942311c75352f763c.jpg";